module.exports = __webpack_public_path__ + "files/1703a14011c28fe4e168eac036fda765.png";